mutation RenameMediaFolder($clientId: ID!, $mediaFolderId: ID!, $newFolderName: String!) {
    renameMediaFolder(clientId: $clientId, mediaFolderId: $mediaFolderId, newFolderName: $newFolderName) {
        id
        name
    }
}
